export default {
  placeholders: {
    delivery_zip_code: 'Postinumero',
    delivery_city: 'Kaupunki',
    delivery_street_number: 'Talon numero',
    delivery_street_name: 'Kadun nimi',
    type_your_address: 'Kirjoita osoitteesi',
  },
  errors: {
    address_suggestions_unavailable: 'Osoite­ehdotuksia ei voitu ladata. Voit silti syöttää osoitteesi alla.',
  },
  buttons: {
    retry: 'Yritä uudelleen',
  },
};
